import type { FindexUser } from "@/types/models/user";
import { getUserFullName } from "@/utils/user";

// Extend Window interface to include Featurebase
declare global {
  interface Window {
    Featurebase: (method: string, config: any, callback?: (err?: Error) => void) => void;
  }
}

export const hideFeatureBase = () => {
  console.log("hide featurebase")
  window.postMessage({
    target: 'FeaturebaseWidget',
    data: {
      action: 'closeWidget'
    }
  });
  document
    .querySelector('[data-featurebase-widget]')
    ?.setAttribute('style', 'display: none !important;');
}

export const showFeatureBase = () => {
  window.postMessage({
    target: 'FeaturebaseWidget',
    data: {
      action: 'changePage',
      payload: 'MainView',
      openWidget: false,
    }
  });
  document
    .querySelector('[data-featurebase-widget]')
    ?.setAttribute('style', 'display: block !important;');
}

const waitForFeaturebase = (maxRetries = 50, interval = 100): Promise<void> => {
  return new Promise((resolve, reject) => {
    let attempts = 0;
    
    const checkFeaturebase = () => {
      if (typeof window.Featurebase === 'function' && !(window.Featurebase as any)._isPlaceholder) {
        // Featurebase is loaded and is the actual SDK function (not our placeholder)
        resolve();
        return;
      }
      
      attempts++;
      if (attempts >= maxRetries) {
        reject(new Error('Featurebase SDK failed to load within timeout'));
        return;
      }
      
      setTimeout(checkFeaturebase, interval);
    };
    
    checkFeaturebase();
  });
};

export const authFeaturebase = async (user: FindexUser) => {
  try {
    // Wait for Featurebase SDK to load
    await waitForFeaturebase();
  } catch (error) {
    console.error('Featurebase SDK not available:', error);
    return;
  }

  window.Featurebase("initialize_portal_widget", {
    organization: 'findex', // Replace this with your organization name, copy-paste the subdomain part from your Featurebase workspace url (e.g. https://*yourorg*.featurebase.app)
    placement: 'right', // optional
    fullScreen: false, // optional
    initialPage: 'MainView', // optional (MainView, RoadmapView, CreatePost, PostsView, ChangelogView, HelpView)
    locale: "en", // Change the language, view all available languages from https://help.featurebase.app/en/articles/8879098-using-featurebase-in-my-language
    metadata: null, // Attach session-specific metadata to feedback. Refer to the advanced section for the details: https://help.featurebase.app/en/articles/3774671-advanced#7k8iriyap66
    userHash: user.featurebaseIdentity
  });

  window.Featurebase("initialize_feedback_widget", {
    organization: "findex",
    theme: "dark", // optional
    defaultBoard: "yourboardname", // optional - preselect a board
    locale: "en", // Change the language, view all available languages from https://help.featurebase.app/en/articles/8879098-using-featurebase-in-my-language
    metadata: null, // Attach session-specific metadata to feedback. Refer to the advanced section for the details: https://help.featurebase.app/en/articles/3774671-advanced#7k8iriyap66
    userHash: user.featurebaseIdentity
  });

  window.Featurebase(
    "identify",
    {
      // Each 'identify' call should include an "organization"
      // property, which is your Featurebase board's name before the
      // ".featurebase.app".
      organization: "findex",
      // Required fields. Replace with your customers data.
      email: user.email,
      name: getUserFullName(user),
      id: user._id,
      userHash: user.featurebaseIdentity,

      // Optional - include other fields as needed
      customFields: {
        title: "Product Manager",
      },
      // Optional, uncomment if you are looking to use multilingual changelog
      // locale: "en", // Will make sure the user receives the changelog email in the correct language
      // Optional - add user company information as needed
      // companies: [
      //   {
      //     id: "987654321", // required
      //     name: "Business Inc. 23", // required
      //     monthlySpend: 500, // optional
      //     createdAt: "2023-05-19T15:35:49.915Z", // optional
      //     customFields: {
      //       industry: "Fintech",
      //       location: "Canada",
      //     }, // optional
      //   },
      // ], // optional
    },
    (err) => {
      // Callback function. Called when identify completed.
      if (err) {
        console.log("ERROR", err)
        // console.error(err);
      } else {
        console.log("Data sent successfully!");
      }
    }
  )
}

export const sendFeaturebaseFeedback = (boardName: string = 'yourboardname') => {
  console.log("sendFeatureBaseFeedback")
  window.postMessage({
      target: 'FeaturebaseWidget',
      data: {
        action: 'openFeedbackWidget',
        setBoard: boardName,
      }
  })
}

export const openHelpCenter = () => {
  window.postMessage({
    target: 'FeaturebaseWidget',
    data: {
      action: 'changePage',
      payload: 'HelpView',
      openWidget: true,
    }
  });
}
